<template>
    <div>
        <group_attr_reference ref="group_attr_reference" :cost_evaluation_id="id" :data="data"
            v-on:need_refresh="() => $emit('need_refresh', selected_attr_reference_row.item)" v-on:edit="ev => $emit('edit', ev)"
        />

        <div v-if="check_roles([ 'model' ]) && !not_editable" class="d-flex justify-content-end mb-2" style="gap: .625rem;">
            <b-button v-if="row_data == selected_attr_reference_row && selected_attr_reference" variant="outline-primary-secondary" v-on:click="group_attr_reference">
                <span>Группировать факторы</span>
            </b-button>
            <b-button v-if="row_data == selected_attr_reference_row && selected_attr_reference" variant="outline-primary-secondary" v-on:click="group_attr_reference_auto_many">
                <span>Разгруппировать</span>
            </b-button>

            <b-button v-if="data.fixed && !new_formula_value" @click="edit_formula_value" variant="outline-primary-secondary">
                <span>Редактировать метки</span><base-icon name="pen" size="md" />
            </b-button>
			<b-button v-if="data.fixed && new_formula_value" @click="cancel_edit_formula_value" variant="outline-primary-secondary">
                <span>Отмена</span>
            </b-button>
			<b-button v-if="data.fixed && new_formula_value" :disabled="!check_formula_value" @click="save_formula_value" variant="primary">
                <span>Сохранить</span>
            </b-button>
        </div>

        <!-- <v-context-menu v-if="! data.fixed && check_roles([ 'model' ]) && !not_editable" ref="context_menu_attrs_references">

            <b-dropdown-item v-on:click="group_attr_reference">Группировать факторы</b-dropdown-item>
            <b-dropdown-item v-on:click="group_attr_reference_auto_many">Разгруппировать</b-dropdown-item>

        </v-context-menu> -->

        <b-table class="mb-0" small sort-by="ind" ref="attr_reference"
            :items="row_data.item.attr_reference_expanded" :fields="reference_fields"
            :selectable="check_roles([ 'model' ]) && !data.fixed" select-mode="single" selected-variant="primary"
			@row-selected="selected_elements => select_row(selected_elements[0], row_data)"
		>
		<!-- v-on:row-contextmenu="( selected_element, index, ev ) => context_menu_attrs_references( selected_element, index, ev, row_data )" -->
			<template #cell(formula_value)="data">

				<b-form-input v-if="new_formula_value" type="number" :value="data.item.formula_value" @input="value => change_formula_value(data.item.value, value)" :state="new_formula_value[data.item.value] !== null" required></b-form-input>
				<template v-else>{{ data.value }}</template>
				
			</template>
		</b-table>
    </div>
</template>

<script>
import group_attr_reference from "./group_attr_reference"
import api from "../../../../../../../api"
import format_expanded_value from "./format_expanded_value"

export default {
    props :
    {
        id : String,
        data : Object,
        row_data : Object,
		not_editable : Boolean
    },

    components :
    {
		group_attr_reference,
    },

    data()
    {
        return {
			new_formula_value : null,
            selected_attr_reference : null,
			selected_attr_reference_row : null,
        }
    },

    computed :
    {
        reference_fields()
		{
			let fields = [
				{ key : "value", label : "Значение фактора" },
			]

			if (this.data.fixed)
			{
				fields.push({ key : "formula_value", label : "Метка", thStyle : "min-width: 100px;", tdClass : "text-right" })
			}
			else
			{
				fields.push(
					{ key : "default", label : "Значение по умолчанию", },
					{ key : "code", label : "Код", tdClass : "text-right" }
				)
			}

			return fields
		},

		check_formula_value()
        {
            return Object.values(this.new_formula_value).filter(value => value === null).length === 0
        }
    },

    methods :
    {
        check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

        context_menu_attrs_references(selected_element, index, ev, row)
		{
			ev.preventDefault()

			this.selected_attr_reference = selected_element
			this.selected_attr_reference_row = row
			this.$refs.context_menu_attrs_references.open(ev)
		},

		select_row(selected_element, row)
		{
			this.selected_attr_reference = selected_element
			this.selected_attr_reference_row = row
		},

		group_attr_reference()
		{
			var raw_values
			var attr = this.selected_attr_reference_row.item

			if(attr.reference != null)
			{
				const histogram = attr.histogram_raw

				raw_values = []

				histogram.forEach(
					desc =>
						raw_values.push(desc[0])
					)
			}

			this.$refs.group_attr_reference.execute(attr, this.selected_attr_reference, raw_values)
		},

		group_attr_reference_auto_many()
		{
			var code = 0
			var values_existed = new Set()
			var attr = this.selected_attr_reference_row.item
			const histogram = api.sort_objects_array_by_key(attr.histogram_raw, 1, true)

			attr.attr_reference = {}

			histogram.forEach(
				desc =>
				{
					const value = desc[0]

					attr.attr_reference[value.toString()] = { default : format_expanded_value(value, attr), code : code.toString() }

					values_existed.add(value)

					code ++
				})

			/*
			var all_values = ( attr.reference == null ) ? [ true, false ] : attr.reference.values

			all_values.forEach(
				value =>
				{
					if(! values_existed.has(value))
					{
						attr.attr_reference[value.toString()] = { default : format_expanded_value(value, attr), code : code.toString() }

						code ++
					}
				})
			*/

			const key = `modeling.attrs_references.${attr.id}.values`
			var fields = {}

			fields[key] = attr.attr_reference

			this.$emit("edit", { fields : fields, save_operation_in_history : true })
			
			// Чушь какая-то с перекрестными ссылками
			this.data.attrs_references[attr.id] = { values : attr.attr_reference }
			
			this.$emit('need_refresh', attr)

            this.$refs.attr_reference.clearSelected()
            this.selected_attr_reference = null
			this.selected_attr_reference_row = null
		},
		
		edit_formula_value()
		{
			this.new_formula_value = this.row_data.item.attr_reference_expanded.reduce((obj, e) => {
				obj[e.value] = e.formula_value
				return obj
			}, {})
		},

		change_formula_value(value, formula_value)
		{
			this.new_formula_value[value] = formula_value === "" ? null : Number(formula_value)
		},

		save_formula_value()
		{
			const params =
			{
				id : this.id,
				type : this.data.type,
				attr : this.row_data.item.id,
				params : this.new_formula_value
			}

			Object.entries(this.new_formula_value).forEach(
				elem =>
				{
					const value = elem[0]
					const formula_value = elem[1]

					var showed_elem = this.row_data.item.attr_reference_expanded.find(showed_elem => showed_elem.value == value)

					if(showed_elem)
						showed_elem.formula_value = formula_value
				})

			api.call(this, "cadastral_cost_evaluation", "set_model_params", params, () => {})

			this.new_formula_value = null
		},

		cancel_edit_formula_value()
		{
			this.new_formula_value = null
		}
    }

}
</script>
